import Layout from '@/layout'

const route = {
  path: '/tencentAD/list',
  component: Layout,
  redirect: '/tencentAD/list',
  alwaysShow: true, // will always show the root menu
  name: 'tencentADList',
  meta: {
    title: '腾讯3.0',
    icon: 'QQ',
    roles: [
      'account_v3'
    ]
  },
  children: [
    {
      path: '/tencentAD/accountAD/index',
      component: () => import('@/views/tencentAD/accountList/index.vue'),
      name: 'tencentADaccountAD',
      meta: {
        title: '广告账户',
        icon: 'component',
        roles: [
          'account_management.advertisers.index'
        ]
      }
    },
    {
      path: '/tencentAD/accountAD/delAdsByProductLog',
      component: () => import('@/views/tencentAD/accountList/delAdsByProductLog.vue'),
      name: 'tencentADDelAdsByProductLog',
      hidden: true,
      meta: {
        title: '删除产品广告日志',
        roles: [
          'account_management.advertisers.index'
        ]
      }
    },
    {
      path: '/tencentAD/WeChatAccount/index',
      component: () => import('@/views/tencentAD/WeChatAccount/index.vue'),
      name: 'tencentWeChatAccount',
      meta: {
        title: '授权账户',
        icon: 'component',
        roles: [
          'account_management.wechat_auth_account.list'
        ]
      }
    },
    {
      path: '/tencentAD/creativity/index',
      component: () => import('@/views/tencentAD/creativity/index.vue'),
      name: 'tencentADcreativity',
      meta: {
        title: '广告创意',
        icon: 'component',
        roles: [
          'ad_management.account_v3.dynamic_creative.index'
        ]
      }
    },
    {
      path: '/tencentAD/adList/index',
      component: () => import('@/views/tencentAD/ADlist/index.vue'),
      name: 'tencentADadList',
      meta: {
        title: '广告',
        icon: 'el-icon-set-up',
        roles: [
          'ad_management.account_v3.adgroups.index'
        ]
      }

    },
    {
      path: '/tencentAD/IntPut/index',
      component: () => import('@/views/tencentAD/IntPut/index.vue'),
      name: 'tencentADIntPut',
      meta: {
        title: '指定账户智能投放',
        icon: 'el-icon-set-up',
        roles: [
          'ad_management.account_v3.adgroups.index'
        ]
      }

    },
    {
      path: '/tencentAD/copyRecord/index',
      component: () => {
        return import('@/views/tencentAD/copyRecord/index.vue')
      },
      name: 'tencentADcopyRecord',
      meta: {
        title: '复制记录',
        icon: 'el-icon-set-up',
        roles: [
          'ad_copy.job_list'
        ]
      }
    },
    {
      path: '/tencentAD/monitoringStrategy/index',
      component: () => import('@/views/tencentAD/monitoringStrategy/index.vue'),
      name: 'tencentADMonitoringStrategy',
      meta: {
        title: '监测策略',
        icon: 'el-icon-view',
        roles: process.env.NODE_ENV === 'development'
          ? undefined
          : ['ad_copy.adq_ads.pause_strategy']
      }
    },
    {
      path: '/property/index',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      name: 'copyRecordIndex',
      meta: {
        title: '资产',
        // icon: 'el-icon-set-up',
        roles: [
          'ad_management.account_v3.material'
        ]
      },
      children: [
        {
          path: '/tencentAD/property/img',
          component: () => {
            return import('@/views/tencentAD/property/imageList.vue')
          },
          name: 'propertyImg',
          meta: {
            title: '素材图片',
            icon: 'el-icon-set-up',
            roles: [
              'ad_management.account_v3.material_images.list'
            ]
          }
        },
        {
          path: '/tencentAD/property/video',
          component: () => {
            return import('@/views/tencentAD/property/videoList.vue')
          },
          name: 'propertyVideo',
          meta: {
            title: '素材视频',
            icon: 'el-icon-set-up',
            roles: [
              'ad_management.account_v3.material_videos.list'
            ]
          }
        },
        {
          path: '/tencentAD/property/danmu',
          component: () => {
            return import('@/views/tencentAD/property/barrageList.vue')
          },
          name: 'propertyDanmu',
          meta: {
            title: '素材弹幕',
            icon: 'el-icon-set-up',
            roles: [
              'ad_management.account_v3.material_barrage.list'
            ]
          }
        },
        {
          path: '/tencentAD/property/brand',
          component: () => {
            return import('@/views/tencentAD/property/brandList.vue')
          },
          name: 'propertyBrand',
          meta: {
            title: '品牌形象',
            icon: 'el-icon-set-up',
            roles: [
              'ad_management.account_v3.material_brand.list'
            ]
          }
        },
        {
          path: '/tencentAD/property/skip',
          component: () => {
            return import('@/views/tencentAD/property/skipList.vue')
          },
          name: 'propertySkip',
          meta: {
            title: '朋友圈头像昵称跳转页',
            icon: 'el-icon-set-up',
            roles: [
              'ad_management.account_v3.material_profiles.list'
            ]
          }
        },
        {
          path: '/tencentAD/property/pages',
          component: () => {
            return import('@/views/tencentAD/property/pagesList.vue')
          },
          name: 'propertyPages',
          meta: {
            title: '原生落地页',
            icon: 'el-icon-set-up',
            roles: [
              'ad_management.account_v3.material_wechat_pages.lis'
            ]
          }
        },
        {
          path: '/tencentAD/property/assetsList',
          component: () => {
            return import('@/views/tencentAD/property/assetsList.vue')
          },
          name: 'propertyAssetsList',
          meta: {
            title: '可投放推广内容资产',
            icon: 'el-icon-set-up',
            roles: [
              'ad_management.account_v3.material_marketing_target'
            ]
          }
        },
        {
          path: '/tencentAD/property/landing_page_sell_strategy',
          component: () => {
            return import('@/views/tencentAD/property/landingPageSellStrategy.vue')
          },
          name: 'LandingPageSellStrategy',
          meta: {
            title: '短剧售卖策略',
            icon: 'el-icon-set-up',
            roles: [
              'ad_management.account_v3.material_marketing_target'
            ]
          }
        },
        {
          path: '/tencentAD/property/feedback_info',
          component: () => {
            return import('@/views/tencentAD/property/feedbackInfo.vue')
          },
          name: 'FeedbackInfo',
          meta: {
            title: '监测链接组',
            icon: 'el-icon-set-up',
            roles: [
              'ad_management.account_v3.material_marketing_target'
            ]
          }
        }
      ]
    },
    {
      path: '/tencentAD/wechatAuthorization/index',
      component: () => import('@/views/messageTemplate/index.vue'),
      name: 'wechatAuthorization',
      meta: {
        title: '微信生态授权管理',
        // icon: 'component',
        roles: [
          'adq_mkt_api_auth'
        ]
      },
      children: [
        {
          path: '/tencentAD/authorizationInof/index',
          component: () => {
            return import('@/views/tencentAD/authorizationInof/index.vue')
          },
          name: 'authorizationInof',
          meta: {
            title: '授权信息',
            // icon: 'el-icon-set-up',
            roles: [
              'adq_mkt_api_auth.manage'
            ]
          }
        },
        {
          path: '/tencentAD/authorizationAccount/index',
          component: () => {
            return import('@/views/tencentAD/authorizationAccount/index.vue')
          },
          name: 'authorizationAccount',
          meta: {
            title: '授权账户',
            // icon: 'el-icon-set-up',
            roles: [
              'adq_mkt_api_auth.account'
            ]
          }
        }
      ]
    },
    {
      path: '/getCopyQueue/getCopyQueue/index',
      component: () => import('@/views/adCopy/getCopyQueue/index.vue'),
      name: 'copyQueue',
      meta: {
        title: '复制队列',
        icon: 'component',
        roles: [
          'ad_copy.get_copy_queue'
        ]
      }
    },
    {
      path: '/tencentAD/backhaul/index',
      component: () => import('@/views/tencentAD/backhaul/index.vue'),
      name: 'tencentADbaclhaul',
      meta: {
        title: '回传配置',
        roles: [
          'ad_management.adq_report'
        ]
      }
    },
    {
      path: '/serviceManagementSet/index',
      component: () => import('@/views/serviceManagementSet/index.vue'),
      name: 'serviceManagementSet',
      meta: {
        title: '企微客服集',
        // icon: 'component',
        roles: [
          'groupSet'
        ]
      }
    },
    {
      path: '/servicemanagement/index',
      component: () => import('@/views/serviceManagement/index.vue'),
      name: 'Servicemanagement',
      meta: {
        title: '企微客服组',
        // icon: 'component',
        roles: [
          'ad_corp'
        ]
      }
    },
    {
      path: '/customerService/index',
      component: () => import('@/views/customerservice/index.vue'),
      name: 'customerService',
      meta: {
        title: '企微客服',
        roles: [
          'ad_corp_back'
        ]
      }
    },
    {
      path: '/crowdpack/index',
      component: () => import('@/views/crowdPack/index.vue'),
      name: 'Crowdpack',
      meta: {
        title: '人群包管理',
        roles: [
          'ad_management.audience'
        ]
      }
    },
    // {
    //   path: '/customerservicegroup/index',
    //   component: () => import('@/views/customerServicegroup/index.vue'),
    //   name: 'customerservicegroup',
    //   meta: {
    //     title: '企业微信客服员工',
    //     roles: [
    //       'distribution.wechatCorp'
    //     ]
    //   }
    // },
    // {
    //   path: '/editAD/index',
    //   name: 'editAD',
    //   component: () => import('@/views/editAD/index.vue'),
    //   meta: {
    //     title: '编辑广告',
    //     roles: [
    //       'ad.manager'
    //     ]
    //   }
    // },
    {
      path: '/editAD/components/details',
      name: 'editAD',
      component: () => import('@/views/editAD/components/details.vue'),
      meta: {
        title: '批量修改行为数据源',
        roles: [
          'advertisers.index'
        ]
      },
      hidden: true
    },
    {
      path: '/sendlink/index',
      component: () => import('@/views/editAD/components/send.vue'),
      name: 'enterpridialog',
      meta: {
        title: '发送记录',
        // icon: 'component',
        roles: [
          'advertisers.index'
        ]
      },
      hidden: true
    },
    {
      path: '/management/index',
      component: () => import('@/views/editAD/components/management.vue'),
      name: 'management',
      meta: {
        title: '违规单据（精准处罚）',
        // icon: 'component',
        roles: [
          'advertisers.index'
        ]
      },
      hidden: true
    },
    {
      path: '/billmeasure/index',
      component: () => import('@/views/editAD/components/billmeasure.vue'),
      name: 'billmeasure',
      meta: {
        title: '违规单据（计量处罚）',
        // icon: 'component',
        roles: [
          'advertisers.index'
        ]
      },
      hidden: true
    },
    {
      path: '/callbackorderlist/index',
      component: () => import('@/views/tencentAD/backhaul/components/orderlist.vue'),
      name: 'management',
      meta: {
        title: '订单列表',
        // icon: 'component',
        roles: [
          'ad_management.adq_report'
        ]
      },
      hidden: true
    }
  ]
}

export default route
